angular.module('common.directives.buttonSliderMenu', [])

    .directive('buttonSliderMenu', function () {
        return {
            restrict: 'E',
            scope: {
                itemTemplate: '@',
                items: "=",
                itemAlias: "@",
                itemClick: "&",
                itemEnabled: "&"
            },
            templateUrl: 'common/directives/buttonSliderMenu/buttonSliderMenu.html',
            controller: 'ButtonSliderMenuController'
        };
    })

    .controller('ButtonSliderMenuController', function ($scope, $element, $window, $swipe, $interval, device) {

        var sliderViewBox = $element.find("#buttonSliderMenu_sliderViewBox");
        var sliderCaret = $element.find("#buttonSliderMenu_sliderCaret");
        var isMoving = false;
        var isSwiping = false;
        var firstTime = true;
        var startPointX;
        var startLeftAttr;

        _.extend($scope, {
            moveLeft: moveLeft,
            moveRight: moveRight,

            canMoveLeft: canMoveLeft,
            canMoveRight: canMoveRight,
            canSwipe: canSwipe,

            onButtonClick: onButtonClick,
            isButtonEnabled: isButtonEnabled,

            getCaretDimensions: getCaretDimensions
        });

        initController();

        function initController() {
            $scope.position = $scope.position || 0;
            initSwipe();
            initWatchers();
        }

        function initWatchers() {
            $scope.$watch($scope.getCaretDimensions, function (newValue, oldValue) {
                if (newValue.width !== oldValue.width && $scope.items && $scope.items.length > 0) {
                    if (sliderCaret.html().indexOf("{{") > 0 || // to prevent animation to width of uncompiled template
                        parseInt(sliderCaret.css("left")) >= 0) {
                        return;
                    }
                    fixPosition();
                    goToPosition(true);
                }
            }, true);

            $scope.$watch('position', function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    fixPosition();
                    goToPosition();
                }
            });

            $scope.$watch('items', function (newValue, oldValue) {
                if (!_.isEqual(angular.toJson(oldValue), angular.toJson(newValue))) {
                    if (firstTime) {
                        isMoving = false;
                        $scope.position = 0;
                        var initOffset = sliderViewBox.width();
                        initOffset = initOffset > 0 ? initOffset : 500;
                        sliderCaret.stop(true, false);
                        sliderCaret.css("left", initOffset);
                        animateCaret(0, 500, "easeOutBounce"); // initial animation
                        firstTime = false;
                    } else {
                        $scope.position = 0;
                        isMoving = false;
                        targetOffset = null;
                        sliderCaret.stop(true, false);
                        sliderCaret.css("left", 0);
                    }
                }
            });

            var intervalPromise = $interval(function () {
                $scope.canSwipe();
            }, 500);

            $scope.$on('$destroy', function () {
                $interval.cancel(intervalPromise);
            });
        }

        function initSwipe() {
            // touch device check
            if (!device.isTouch()) {
                return;
            }

            $swipe.bind($(sliderViewBox), {
                start: function (point) {
                    isSwiping = true;
                    isMoving = false;
                    targetOffset = null;
                    sliderCaret.stop(true, false);

                    startPointX = point.x;
                    startLeftAttr = parseInt(sliderCaret.css("left"));
                },
                end: function () {
                    isSwiping = false;
                    fixPositionFromOffset();
                    goToPosition();
                },
                move: function (point) {
                    var delta = point.x - startPointX;
                    sliderCaret.css("left", startLeftAttr + delta);
                },
                cancel: function () {
                    isSwiping = false;
                    fixPositionFromOffset();
                    goToPosition();
                }
            });
        }

        /**
         * Check if we see all the buttons
         * @returns {boolean}
         */
        function canSwipe() {
            return !isSwiping && (sliderCaret.width() > sliderViewBox.width() || parseInt(sliderCaret.css("left")) != 0);
        }

        function fixPositionFromOffset() {
            try {
                var currentOffset = -parseInt(sliderCaret.css("left")); // reversed sign!

                if (currentOffset <= 0) {
                    $scope.position = 0;
                    return;
                }
                var children = sliderCaret.children();
                if (children.length <= 1 || currentOffset < $(children[0]).width() / 2) {
                    $scope.position = 0;
                    return;
                }

                var offset = 0;
                for (var i = 0; i < children.length - 1; i++) {
                    var el = $(children[i]);
                    var nextEl = $(children[i + 1]);
                    if (currentOffset > offset + el.width() / 2 &&
                        currentOffset < offset + el.width() + nextEl.width() / 2) {
                        $scope.position = i + 1;
                        return;
                    }
                    offset += el.width();
                }

                $scope.position = children.length - 1;

            } catch (e) { // stability improvement! =)
                $log.error('Error in button slider menu', e);
                $scope.position = 0;
            }
        }

        function fixPosition() {
            if ($scope.position <= 0) {
                $scope.position = 0;
            } else if ($scope.position >= $scope.items.length) {
                $scope.position = $scope.items.length - 1;
            }
        }

        function goToPosition(quick) {
            if (sliderCaret.width() <= sliderViewBox.width()) {
                $scope.position = 0;
            }
            if ($scope.position == 0) {
                if (quick) {
                    isMoving = false;
                    targetOffset = null;
                    sliderCaret.stop(true, false);
                    sliderCaret.css("left", 0);
                } else {
                    animateCaret(0);
                }
                return;
            }

            var offset = 0;
            var children = sliderCaret.children();
            for (var i = 0; i < $scope.position; i++) {
                offset += $(children[i]).width();
            }

            if (quick) {
                isMoving = false;
                targetOffset = null;
                sliderCaret.stop(true, false);
                sliderCaret.css("left", -offset);
            } else {
                animateCaret(-offset);
            }
        }

        /**
         * Move one item to the left
         */
        function moveLeft() {
            if (!canMoveLeft()) {
                return;
            }
            $scope.position++;
        }

        /**
         * Move one item to the right
         */
        function moveRight() {
            if (!canMoveRight()) {
                return;
            }
            $scope.position--;
        }

        function canMoveLeft() {
            return $scope.items && $scope.position < $scope.items.length - 1 && canSwipe();
        }

        function canMoveRight() {
            return $scope.position > 0 && canSwipe();
        }

        var targetOffset;

        /**
         * Animate slider caret
         * @param {string|number} [offset] offset of new caret position OR modification expression like "+={number}". Default value is 0.
         * @param {number} [duration] duration of animation. Default value is 400ms.
         * @param {string} [easing] easing name. To use custom easing function you need to connect jQuery easing plugin.
         */
        function animateCaret(offset, duration, easing) {
            if (parseInt(offset) == targetOffset) {
                return;
            }

            sliderCaret.stop(true, false);
            isMoving = true;
            targetOffset = parseInt(offset);
            sliderCaret.animate(
                {left: offset || 0},
                duration || 400,
                easing || "easeInOutExpo",
                function () {
                    isMoving = false;
                    targetOffset = null;
                });
        }

        function onButtonClick(item) {
            if (!item || !$scope.itemClick || !isButtonEnabled(item)) {
                return;
            }
            var params = {};
            params[$scope.itemAlias || "item"] = item;
            $scope.itemClick(params);
        }

        function isButtonEnabled(item) {
            if (!item || !$scope.itemEnabled) {
                return true;
            }
            var params = {};
            params[$scope.itemAlias || "item"] = item;
            return $scope.itemEnabled(params);
        }

        function getCaretDimensions() {
            return {
                height: sliderCaret.height(),
                width: sliderCaret.width()
            };
        }
    })

;
